module.exports = __webpack_public_path__ + "@/assets/img/jcb.cb4de2c4.svg";